// extracted by mini-css-extract-plugin
export var csatScore = "_le-5";
export var header = "_le-1";
export var panelWrapper = "_le-2";
export var postPreview = "_le-3";
export var rightContent = "_le-0";
export var wrappingText = "_le-4";